import React, { Component } from "react";
import ConvertersPool from "../../containers/ConvertersPoolContainer";
import { currentLocals } from "../../languages/languages.js";
import Toolbar from "../../containers/ToolBarContainer";
import MyFlag from "../../containers/FeatureContainer";
import ToolBarBottom from "../../containers/ToolBarBottomContainer";

export default class ConvertersPannel extends Component {
  constructor() {
    super();
    this.UpdateCurrentDragging = this.UpdateCurrentDragging.bind(this);
  }
  state = {
    currentDragging: "",
  };

  UpdateCurrentDragging(name) {
    this.setState({ currentDragging: name });
  }

  handleShowConvertersmanager = () => {
    var x = document.getElementsByClassName("ToolbarManagerContainer");
    var i;
    for (i = 0; i < x.length; i++) {
      x[i].style.display = "";
    }

    let convertermanager = document.getElementById("convertermanager");
    convertermanager.style.width = "500px";
    convertermanager.style.visibility = "hidden";

    let op = 0.1;
    let timer = setInterval(fadeIn, 5);
    function fadeIn() {
      convertermanager.style.visibility = "visible";
      if (op >= 0.95) {
        clearInterval(timer);
      }
      convertermanager.style.opacity = op;
      op += op * 0.5;
    }
  };

  handleAdd = () => {
    const { addConverter, converters } = this.props;

    let newid = "converter1";

    for (let ndx = 1; ndx < 100; ndx++) {
      newid = "converter" + ndx;
      if (converters.findIndex((converter) => converter.id === newid) < 0) break;
    }
    ///////////////////////////////////////////////////////////////////
    const typeInOut = this.props.typeInOut;
    let mytypeOrigin, mytypeDestination, mytypeInOut;
    if (typeInOut === "In") {
      mytypeOrigin = "accumark";
      mytypeDestination = "mdl";
      mytypeInOut = typeInOut;
      addConverter({
        id: newid,
        type: mytypeOrigin,
        typeDestination: mytypeDestination,
        typeInOut: mytypeInOut,
      });
    } else if (typeInOut === "Out") {
      mytypeOrigin = "mdl";
      mytypeDestination = "dxf-extended";
      mytypeInOut = typeInOut;
      addConverter({
        id: newid,
        type: mytypeOrigin,
        typeDestination: mytypeDestination,
        typeInOut: mytypeInOut,
      });
    }
    // ir a store\sagas\converters.js para la función  addConverter
    //////////////////////////////////////////////////////
  };

  handleCopy = () => {
    const { copyConverter, converters } = this.props;
    //const { currentDragging } = this.state;
    let currentDragging = this.props.draggedConverter;

    const index = converters.findIndex((converter) => converter.id === currentDragging);
    if (index >= 0) {
      const type = converters[index].type;
      const typeDestination = converters[index].typeDestination;
      const typeInOut = converters[index].typeInOut;
      copyConverter({ id: currentDragging, type, typeDestination, typeInOut });
    }
  };

  handleRemove = () => {
    const { removeConverter } = this.props;
    //const { currentDragging } = this.state;
    let currentDragging = this.props.draggedConverter;
    if (window.confirm(currentLocals(this.props.locale).converter.sure_to_delete + currentDragging.toUpperCase())) {
      removeConverter({ id: currentDragging });
    }
  };

  getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      vars[key] = value;
    });
    return vars;
  }
  getUrlParam(parameter, defaultvalue) {
    var urlparameter = defaultvalue;
    if (window.location.href.indexOf(parameter) > -1) {
      urlparameter = this.getUrlVars()[parameter];
    }
    return urlparameter;
  }

  render() {
    const { converters } = this.props; //accesssing  a property stored in store
    const typeInOut = this.props.typeInOut; //Parameter, passed in ConvertersPool calling in Main.js
    const commands = [
      {
        label: "cmdConvertersmanager",
        command: this.handleShowConvertersmanager,
      },
      /*{
        label: "cmdAdd",
        command: this.handleAdd,
      },*/
      {
        label: "cmdCopy",
        command: this.handleCopy,
      },
      {
        label: "cmdRemove",
        command: this.handleRemove,
      },
    ];
    let converterIn = [];
    let converterOut = [];
    let converterToShow = [];
    for (let i = 0; i < converters.length; i++) {
      var currentConverter = converters[i];
      if (
        currentConverter.type === "accumark" ||
        currentConverter.type === "aama_astm" ||
        currentConverter.typeInOut === "In"
      ) {
        converterIn.push(currentConverter);
      } else if (currentConverter.type === "mdl" || currentConverter.typeInOut === "Out") {
        converterOut.push(currentConverter);
      }
    }
    if (this.props.typeInOut === "In") {
      converterToShow = converterIn;
    }
    if (this.props.typeInOut === "Out") {
      converterToShow = converterOut;
    }
    //TOMA DE PARAMETROS
    const Connected = this.getUrlParam("connected", "No");
    const Mode = this.getUrlParam("mode", "InOut");

    /*
      localhost:3000/?mode=In&connected=Yes
      localhost:3000/?mode=Out&connected=Yes
      localhost:3000/?mode=In&connected=Yes


      localhost:3000/?mode=InOut&connected=Yes
      localhost:3000/?mode=InOut&connected=No

    */

    const renderToolBarBottomIConnected = () => {
      if (Connected == "Yes")
        return (
          <div>
            <ToolBarBottom />
          </div>
        );
    };
    const renderConvertersPoolInOut = () => {
      //alert(Mode);
      if (Mode == "In")
        return (
          <div>
            <ConvertersPool typeInOut="In" />
          </div>
        );
      else if (Mode == "Out")
        return (
          <div>
            <ConvertersPool typeInOut="Out" />
          </div>
        );
      else if (Mode == "InOut")
        return (
          <div>
            <ConvertersPool typeInOut="In" />
            <ConvertersPool typeInOut="Out" />
          </div>
        );
      else
        return (
          <div>
            <ConvertersPool typeInOut="In" />
            <ConvertersPool typeInOut="Out" />
          </div>
        );
    };
    return (
      <div>
        <div className="ConverterPannel" data-tut="reactour__converterspannel">
          <div>
            {renderConvertersPoolInOut()}
            <MyFlag flag="typeInOut">
              <div id="dxf-extended-exist"></div>
            </MyFlag>
            {renderToolBarBottomIConnected()}
          </div>
        </div>
      </div>
    );
  }
}
